import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initClientIpCache } from './utils/clientMeta';

initClientIpCache().catch(() => {});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
